import { render } from "./setup.vue?vue&type=template&id=319e9ef8&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"

import "./setup.vue?vue&type=style&index=0&id=319e9ef8&scoped=true&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/codfather/email nationalGrid/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319e9ef8"]])

export default __exports__